import { Controller } from 'stimulus';
import jump from 'jump.js';

class FooterController extends Controller {
  // eslint-disable-next-line class-methods-use-this
  onArrowClick() {
    jump(document.body);
  }
}

FooterController.targets = [
  //
];

export default FooterController;
